import { groupBy } from 'lodash';

class ReservationItemsController {

    constructor(basket) {
        basket.promise && basket.promise.then(() => {
            this.basket = basket;
            this.transformReservationItems();
        });
    }

    transformReservationItems () {
        if (this.hasReservation()) {

            this.reservation = groupBy(this.basket.contents.reservation.guests, (reservation) => {
                return reservation.guest;
            });
        }
    }

    hasReservation () {
        return !!(this.basket
            && this.basket.contents
            && this.basket.contents.reservation);
    }
}

ReservationItemsController.$inject = ['basket'];

export default ReservationItemsController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/basket/controllers/reservationItems.controller.js